import "react-datepicker/dist/react-datepicker.css";
import "./comn/assets/styles/index.css";
import App from "./App";
import ReactDOM from "react-dom/client";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);
